import debug from 'debug'

export const makeLogger = (name: string) => debug(name)
